module.exports = __webpack_public_path__ + "images/c0339c611fcb98688dfa56badff94cb2.png";